import { z } from "zod";
/** Revision is the full SHA in the current Worker version tag; untagged versions report null. */
export const DeployedVersion = z.object({
  revision: z.string().regex(/^[a-f0-9]{40}$/).nullable(),
  environment: z.enum(["local", "staging", "production"]),
  version_id: z.string().nullable(),
  deployed_at: z.iso.datetime().nullable(),
});
export type DeployedVersion = z.infer<typeof DeployedVersion>;
